export const REVOKED_BY_PROFILE_DELETED = 'Profile Deleted';
